import { MeetConstants } from '../meet/meet.constants';

// Amplitude properties describing the audience filters chosen for a campaign.
// Only filter, category, and option IDs are sent; never customer IDs or saved group names.
export function getAudienceFilterAnalytics(customerAPIRequest: any, allCustomersSelected: boolean) {
  const filters: any[] = customerAPIRequest?.selectedFilters ?? [];
  const hasCustomers = (id: string) => filters.some(f => f.id === id && f.cfaIdList?.length > 0);
  const audienceFilters = filters.filter(f => f.id !== MeetConstants.includeFilterId && f.id !== MeetConstants.excludeFilterId);

  const filterOptions = audienceFilters.flatMap(f => [
    ...(f.selectedButtonToggle ? [`${f.id}:${f.selectedButtonToggle}`] : []),
    ...(f.selectedButtonChipSections ?? []).flatMap(section =>
      (section.selectedButtonChips ?? []).map(chip => `${f.id}:${chip}`)),
    ...(f.subOptions ?? []).filter(subOption => subOption.selected).map(subOption => `${f.id}:${subOption.id ?? subOption.name}`)
  ]);

  return {
    'Filter Ids': audienceFilters.map(f => f.id),
    'Filter Categories': [...new Set(audienceFilters.map(f => f.parentCategory).filter(Boolean))],
    'Filter Options': filterOptions,
    'Number Of Filters': audienceFilters.length,
    'Number Of Saved Groups': customerAPIRequest?.customGroupIds?.length ?? 0,
    'Individual Customers Included': hasCustomers(MeetConstants.includeFilterId),
    'Individual Customers Excluded': hasCustomers(MeetConstants.excludeFilterId),
    'All Customers Selected': allCustomersSelected
  };
}
